import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { TResponse } from "../../../types/common";
import { IStatusHistory, TStatusHistoryEntityType } from "../../../types/api/statusHistory";
import { listStatusHistory } from "./callbacks";

export const useStatusHistory = (
  params: { entity_type: TStatusHistoryEntityType; entity_id: number } | null,
  options?: Omit<UseQueryOptions<TResponse<IStatusHistory[]>, Error>, "queryKey" | "queryFn">,
): UseQueryResult<TResponse<IStatusHistory[]>, Error> => {
  return useQuery<TResponse<IStatusHistory[]>, Error>({
    queryKey: [API_ENDPOINTS.STATUS_HISTORY_LIST, params],
    queryFn: () => listStatusHistory(params!).then((r) => r.data),
    enabled: !!params,
    ...options,
  });
};
